import getSmartRepliesForItem from '../utils/getSmartRepliesForItem';
import { ClientItem } from 'owa-mail-store';
import { SmartPillBuilder } from 'owa-smart-pill';

export default function createSmartReplyPillBuilder(item: ClientItem): SmartPillBuilder {
    return {
        buildPills: async () => {
            return getSmartRepliesForItem(item);
        },
        getName: () => {
            return 'SmartReply';
        },
    };
}
